import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';

const { INFLUENCERS } = API.END_POINTS;

const DATA_LOADING = 'instagramInfluencers/DATA_LOADING';
const DATA_LOADED = 'instagramInfluencers/DATA_LOADED';
const RESET = 'instagramInfluencers/RESET';

import type {
  Action,
  Dispatch,
  GetState,
  InfluencerInstagram,
  ThunkAction
} from 'types';

const initialState = {
  mapByUsername: {}
};

const dataLoaded = (username: string, data: InfluencerInstagram): Action => ({
  type: DATA_LOADED,

  payload: {
    username,
    data
  }
});

export const resetInstagramInfluencers = (): Action => ({
  type: RESET,
  payload: {}
});

export function fetchInstagramProfile(username: string = ''): ThunkAction {
  return async (dispatch: Dispatch, getState: GetState) => {
    const mapByUsername = getState().instagramInfluencers.mapByUsername;

    if (mapByUsername[username]) {
      return;
    }

    try {
      const url = INFLUENCERS.getInstagramInfluencer(username);
      const response = await get(url);

      dispatch(dataLoaded(username, response.data));
    } catch (e) {
      logError(e);
    }
  };
}

export default createReducer<any, any>('instagramInfluencers', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [DATA_LOADING]: (state, { status }) => ({
    ...state,
    isLoading: status
  }),
  [DATA_LOADED]: (state, { username, data }) => ({
    ...state,
    mapByUsername: {
      ...state.mapByUsername,
      [username]: data
    }
  })
});
